var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [
        _vm._v(
          _vm._s(_vm.$t("components.orderDetailsForOrderItem.header")) +
            " " +
            _vm._s(_vm.data.orderItem.id)
        )
      ]),
      _c(
        "p",
        { staticStyle: { "font-size": "larger" } },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("components.orderDetailsForOrderItem.forOrderNumber")
              ) +
              " " +
              _vm._s(_vm.data.id) +
              " "
          ),
          _vm._t("default"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("components.orderDetailsForOrderItem.created")) +
              ": " +
              _vm._s(_vm.data.created_at) +
              " " +
              _vm._s(_vm.$t("components.orderDetailsForOrderItem.createdBy")) +
              " "
          ),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.data.created_by_name))
          ]),
          _vm._v(" email: "),
          _c("a", { attrs: { href: "mailto:" + _vm.data.created_by_email } }, [
            _vm._v(_vm._s(_vm.data.created_by_email))
          ]),
          _vm._v(" " + _vm._s(_vm.$t("global.phone")) + ": "),
          _c("b", [_vm._v(_vm._s(_vm.data.created_by_phone))]),
          _vm._v(". ")
        ],
        2
      ),
      _c("h2", [
        _vm._v(
          _vm._s(_vm.$t("components.orderDetailsForOrderItem.ordering")) + ":"
        )
      ]),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "py-1 px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  filled: "",
                  label: _vm.$t(
                    "components.orderDetailsForOrderItem.companyName"
                  ),
                  readonly: ""
                },
                model: {
                  value: _vm.data.contractor_name,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "contractor_name", $$v)
                  },
                  expression: "data.contractor_name"
                }
              }),
              _c("v-text-field", {
                attrs: {
                  filled: "",
                  label: _vm.$t("global.tin"),
                  readonly: ""
                },
                model: {
                  value: _vm.data.contractor_tin,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "contractor_tin", $$v)
                  },
                  expression: "data.contractor_tin"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-textarea", {
                staticClass: "input-capitalize",
                attrs: {
                  value: _vm.address,
                  filled: "",
                  height: "145px",
                  label: _vm.$t("global.address"),
                  "no-resize": "",
                  readonly: ""
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  filled: "",
                  height: "145px",
                  label: _vm.$t("global.comment"),
                  "no-resize": "",
                  readonly: "",
                  outlined: ""
                },
                model: {
                  value: _vm.data.service_order_comment,
                  callback: function($$v) {
                    _vm.$set(_vm.data, "service_order_comment", $$v)
                  },
                  expression: "data.service_order_comment"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  readonly: "",
                  value: _vm.data.order_group_id,
                  filled: "",
                  label: _vm.$t(
                    "components.orderDetailsForOrderItem.idOrderGroup"
                  ),
                  "append-outer-icon": "fa-copy"
                },
                on: {
                  "click:append-outer": function($event) {
                    return _vm.$copyText(_vm.data.order_group_id)
                  }
                }
              })
            ],
            1
          ),
          !!_vm.data.project_name && _vm.data.project_name.length > 0
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      readonly: "",
                      value: _vm.data.project_name,
                      filled: "",
                      label: _vm.$t(
                        "components.orderDetailsForOrderItem.projectAttribute"
                      ),
                      "append-outer-icon": "fa-copy"
                    },
                    on: {
                      "click:append-outer": function($event) {
                        return _vm.$copyText(_vm.data.project_name)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !!_vm.data.order_number && _vm.data.order_number.length > 0
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      readonly: "",
                      value: _vm.data.order_number,
                      filled: "",
                      label: _vm.$t(
                        "components.orderDetailsForOrderItem.orderNumberAttribute"
                      ),
                      "append-outer-icon": "fa-copy"
                    },
                    on: {
                      "click:append-outer": function($event) {
                        return _vm.$copyText(_vm.data.order_number)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !!_vm.data.external_customer_name &&
          _vm.data.external_customer_name.length > 0
            ? _c(
                "v-col",
                { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      readonly: "",
                      value: _vm.data.external_customer_name,
                      filled: "",
                      label: _vm.$t(
                        "components.orderDetailsForOrderItem.clientAttribute"
                      ),
                      "append-outer-icon": "fa-copy"
                    },
                    on: {
                      "click:append-outer": function($event) {
                        return _vm.$copyText(_vm.data.external_customer_name)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("p", { staticStyle: { "font-size": "larger" } }, [
        _vm.data.phone_numbers != null && _vm.data.phone_numbers.length > 3
          ? _c("span", { staticStyle: { "text-transform": "capitalize" } }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("global.phone")) +
                  ": " +
                  _vm._s(_vm.data.phone_numbers)
              ),
              _c("br")
            ])
          : _vm._e(),
        _vm.data.contractor_mail_addresses != null &&
        _vm.data.contractor_mail_addresses.length > 3
          ? _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("components.orderDetailsForOrderItem.companyEmail")
                  ) +
                  ": "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "mailto:" + _vm.data.contractor_mail_addresses
                  }
                },
                [_vm._v(_vm._s(_vm.data.contractor_mail_addresses))]
              ),
              _c("br")
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }